import { packagePrice } from './package-price.js';

/** CRM display convention. Amounts remain integer minor units everywhere in storage. */
export function formatCrmMoney(value: number | null, currency: string, exact = false) {
  if (value === null) return 'Not set';
  const amount = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: 0,
    maximumFractionDigits: exact ? 2 : 0,
  }).format(value / 100);
  const symbol =
    new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
      currencyDisplay: 'symbol',
    })
      .formatToParts(0)
      .find((part) => part.type === 'currency')?.value ?? currency;
  return `${amount}\u00a0${symbol}`;
}

/** Reformat numeric package labels while preserving quote/range copy and prefixes. */
export function formatCrmPriceLabel(label: string | null | undefined) {
  if (!label) return label;
  const parsed = packagePrice(label);
  if (!parsed) return label;
  const prefix = /^\s*(from|starting\s+(?:at|from))\s+/i.exec(label)?.[0].trim();
  return `${prefix ? `${prefix} ` : ''}${formatCrmMoney(parsed.amountMinor, parsed.currency)}`;
}

/** Editable amounts omit padding zeros while retaining actual minor units. */
export function formatCrmMoneyInput(amountMinor: number) {
  return String(amountMinor / 100);
}
